// src/components/ProtectedRoute.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
    const { user } = useAuth();

    if (!user) {
        // Si no hay ningún usuario logueado, redirige a la página de inicio.
        return <Navigate to="/" />;
    }

    // Si hay un usuario, permite el acceso al componente hijo (la página).
    return children;
}

export default ProtectedRoute;